import React from "react";

import {
  Button,
  Checkbox,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteProjectsField,
  deleteProjectsField,
  getProjectsField,
  UpdateProjectsField,
  updateProjectsField,
  AddProjectsField,
} from "../../../../actions/companySettings";
import { employees } from "../../../../actions/employees";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import "./../../styles/setting.css";
import "./../Custom.css";
import AddProjectField from "./AddProjectField";

const { Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Projects Head",
    dataIndex: "user_name",
    key: "user_name",
  },
];

message.config({
  maxCount: 3,
});

const Projects = () => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [projectsFields, setProjectsFields] = React.useState([]);
  const [employeesData, setemployeesData] = React.useState([]);

  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );
  const projectsFieldResponse = useSelector(
    (state) => state.companySetting.getProjectsField || {},
  );
  const deleteProjectsFieldResponse = useSelector(
    (state) => state.companySetting.deleteProjectsField || {},
  );
  const addProjectsFieldResponse = useSelector(
    (state) => state.companySetting.addProjectsField || {},
  );
  const updateProjectsFieldResponse = useSelector(
    (state) => state.companySetting.updateProjectsField || {},
  );
  const employeesResponse = useSelector(
    (state) => state.employees.employees || {},
  );
  const {
    data: { response: { employees: employeesRecord = [] } = {} } = {},
    success = false,
  } = employeesResponse;

  React.useEffect(() => {
    // dispatch(companySetting({ show: 'id' }));
    dispatch(getProjectsField({}));
    dispatch(employees(objectToFormData({ status: true })));
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (success) {
      setemployeesData(employeesRecord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = false, errors = "" } = {},
    } = updateCompanySettingResponse;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateProjectsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getProjectsField({}));
      dispatch({
        type: UpdateProjectsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateProjectsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateProjectsFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteProjectsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getProjectsField({}));
      dispatch({
        type: DeleteProjectsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteProjectsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteProjectsFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addProjectsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getProjectsField({}));
      dispatch({
        type: AddProjectsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddProjectsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addProjectsFieldResponse]);

  React.useEffect(() => {
    const { data: { response: { projects = [] } = {}, status = false } = {} } =
      projectsFieldResponse;
    if (status) {
      setProjectsFields(projects);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectsFieldResponse]);

  const tableAction = [
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          onChange={(e) =>
            dispatch(
              updateProjectsField(
                objectToFormData({
                  id: record.id,
                  is_enable: e.target.checked,
                }),
              ),
            )
          }
          defaultChecked={status}
          disabled={!hasAccess("projects", "write")}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) =>
        hasAccess("projects", "write") && (
          <Space key={record.id} size="middle">
            <button onClick={() => showEditModal(record.id)}>
              <img src={EditIcon} alt={"logo"} className="action-logo" />
            </button>
            <button onClick={() => showDeleteModal(record.id)}>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />
            </button>
          </Space>
        ),
    },
  ];

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  function handleButtonClick(e) {
    showModal();
  }

  const renderDeleteOption = () => {
    return (
      <>
        <Text>
          If you delete this Projects, the users will not no longer be
          associated to this Projects. Are you sure you want to delete it?
        </Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteProjectsField(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Project
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Project" : "New Project"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        {modalType === "center" ? (
          renderDeleteOption()
        ) : (
          <AddProjectField
            id={selectedId}
            handleCancel={handleCancel}
            employeesData={employeesData}
          />
        )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Projects`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            Projects: null,
          }}
        />
      </div>
      {hasAccess("projects", "write") && (
        <Button onClick={handleButtonClick} className="mb1 ml1 addNew">
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New
        </Button>
      )}
      <Table
        rowKey="id"
        columns={[...columns, ...tableAction]}
        dataSource={projectsFields}
        className="settingsTable"
      />
    </>
  );
};

export default Projects;

// projects_prefix = 'rr',
// projects_reminder = false,
// projects_reminder_days = '10',
// projects_starts_with = null,
